import axios from "../../axiosInstance";
import type { Badge, BadgeCreateRequest } from "@/modules/learningCenter/features/BadgeManagement/types/badge.types";

export const createBadge = async (data: BadgeCreateRequest): Promise<Badge> => {
  console.log('=== BADGE CREATE REQUEST ===');
  console.log('Data being sent:', data);
  console.log('Request URL: /api/badges');

  try {
    const response = await axios.post("/api/badges", data);
    console.log('=== BADGE CREATE SUCCESS ===');
    console.log('Response:', response.data);

    // Transform snake_case response to camelCase
    const transformedResponse: Badge = {
      id: response.data.id,
      name: response.data.name,
      description: response.data.description,
      iconType: response.data.icon_type,
      iconValue: response.data.icon_value,
      pointValue: response.data.point_value,
      badgeType: response.data.badge_type,
      isActive: response.data.is_active,
      createdAt: response.data.created_at,
      updatedAt: response.data.updated_at,
      createdBy: response.data.created_by,
      parentBadgeId: response.data.parent_badge_id
    };

    return transformedResponse;
  } catch (error: any) {
    console.error('=== BADGE CREATE ERROR ===');
    console.error('Error object:', error);
    console.error('Error response:', error.response);
    console.error('Error response data:', error.response?.data);
    console.error('Error message:', error.message);
    throw error;
  }
};

export default createBadge;
